import React, { useState } from "react";
import BatchItem from "./BatchItem";
import ViewBatchData from "./viewBatchData";


const BatchList = ({ batches, onUpload }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedBatchId, setSelectedBatchId] = useState(null);

  const handleViewData = (batchId) => {
    setSelectedBatchId(batchId);
    setOpenDrawer(true);
  };

  return (
    <>
      {batches.map((batch) => (
        <BatchItem
          key={batch.id}
          batch={batch}
          onUpload={onUpload}
          onViewData={handleViewData}
        />
      ))}

      <ViewBatchData
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        batchId={selectedBatchId}
      />
    </>
  );
};

export default BatchList;
